import { RouteComponentProps } from 'react-router';
import queryString from 'query-string';

import _isEmpty from 'lodash-es/isEmpty';
import _isFinite from 'lodash-es/isFinite';
import _last from 'lodash-es/last';

import {
  QueryArgs,
  ViewMode,
  isViewMode
} from 'Types/Designs';
import { deserializeRgbs } from 'Utils/Rgb';

export function isPathCustom(pathname: string): boolean {
  const filtered = pathname.split('/').filter(x => !!x);

  const pieces = filtered.map(x => x.toLowerCase());

  return pieces.length === 3 && _last(pieces) === 'custom';
}

type RouterProps = RouteComponentProps<{ designCode: string, colorCode?: string }>;

export function parseQueryArgs(props: Partial<RouterProps>): QueryArgs {
  const query: any = queryString.parse(props.location.search) as any || {};

  const result: QueryArgs = {
    designCode: (props.match.params.designCode || '').toUpperCase()
  };

  if (!_isEmpty(props.match.params.colorCode)) {
    result.colorCode = props.match.params.colorCode.toUpperCase();
  }

  if (!_isEmpty(query['ref'])) {
    result.refColorCode = query['ref'];
  } else {
    result.refColorCode = '';
  }

  if (!_isEmpty(query['refLibs'])) {
    result.refLibs = query['refLibs'];
  } else {
    result.refLibs = '';
  }

  if (!_isEmpty(query['rgb'])) {
    result.rgbs = deserializeRgbs(query['rgb']);
  } else {
    result.rgbs = [];
  }

  if (!_isEmpty(query['clut'])) {
    result.clutColorwayId = query['clut'];
  }

  if (!_isEmpty(query['y'])) {
    result.yarnCodes = (query['y'] as string)
      .split(',')
      .map(y => y.toUpperCase());
  } else {
    result.yarnCodes = [];
  }

  if (!_isEmpty(query['m'])) {
    result.mutedIndices = (query['m'] as string)
      .split(',')
      .map(m => +m);
  } else {
    result.mutedIndices = [];
  }

  if (Number.isInteger(+query['t']) && +query['t'] > 0) {
    result.textureId = +query['t'];
  }

  if (!_isEmpty(query['v']) && isViewMode(query['v'] as string)) {
    result.viewMode = query['v'] as ViewMode;
  }

  if (Number.isInteger(+query['i']) && +query['i'] > 0) {
    result.installId = +query['i'];
  }

  if (Number.isInteger(+query['r']) && +query['r'] > 0) {
    result.roomId = +query['r'];
  }

  if (Number.isInteger(+query["rugwidth"]) && Number.isInteger(+query["rugheight"]) && +query["rugwidth"] > 0 && +query["rugheight"] > 0) {
    result.rugWidth = +query["rugwidth"];
    result.rugHeight = +query["rugheight"];
  }

  if (!_isEmpty(query["rugshape"])) {
    result.rugShape = query["rugshape"] as string;
  }

  if (Number.isInteger(+query['rot']) && +query['rot'] > 0) {
    result.rotation = +query['rot'];
  } else {
    result.rotation = 0;
  }

  if (_isFinite(+query['t_x']) && _isFinite(+query['t_y'])) {
    result.position = {
      translate: { x: +query['t_x'], y: +query['t_y'] },
      textureOrigin: null
    };
  }

  if (_isFinite(+query['to_x']) && _isFinite(+query['to_y'])) {
    result.position = {
      translate: null,
      textureOrigin: { x: +query['to_x'], y: +query['to_y'] }
    };
  }

  if (Number.isInteger(+query['folderId']) && +query['folderId'] > 0) {
    result.folderId = +query['folderId'];
  }

  return result;
}
